import React, { useState, useEffect, Fragment } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Table } from "react-bootstrap";
import EditModal from "./EditModal";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import HandleHttpErrors from "../../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  nazeegTypeOptions,
  megdarOptions,
}) => {
  const [members, setMembers] = useState(null);
  const [memberId, setMemberId] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get("/jobs/memberlist/", {
          signal: controller.signal,
        });

        isMounted &&
          setMembers(
            response.data.sort((a, b) => (a.start_date < b.start_date ? 1 : -1))
          );
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [counter]);
  const handleEditClick = (event, member) => {
    event.preventDefault();
    setShowEdit(true);
    setMemberId(member.id);
  };

  const handleCancelClick = () => {
    setMemberId(null);
  };

  if (!members) return null;
  return (
    <>
      <div className="mx-auto">
        <Row>
          <Col sm="10" md={{ size: 3, offset: 1 }}>
            <form onSubmit={increment}>
              <Table hover>
                <thead>
                  <tr>
                    <th>שם פרטי</th>
                    <th>שם משפחה</th>
                    <th>ת"ז</th>
                    <th>סוג הנציג</th>
                    <th>טלפון</th>
                    <th>דואר אלקטרוני</th>
                    <th>פעיל</th>
                  </tr>
                </thead>
                <tbody>
                  {members?.map((member) => (
                    <Fragment key={member.id}>
                      {memberId === member.id ? (
                        <EditModal
                          showEdit={showEdit}
                          setShowEdit={setShowEdit}
                          member={member}
                          increment={increment}
                          nazeegTypeOptions={nazeegTypeOptions}
                          setMemberId={setMemberId}
                          megdarOptions={megdarOptions}
                          handleCancelClick={handleCancelClick}
                        />
                      ) : (
                        <ReadOnlyRows
                          member={member}
                          handleEditClick={handleEditClick}
                          increment={increment}
                          nazeegTypeOptions={nazeegTypeOptions}
                          setMemberId={setMemberId}
                          setShowError={setShowError}
                          setErrorMessage={setErrorMessage}
                          setErrorHeader={setErrorHeader}
                        />
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </Table>
            </form>
          </Col>
        </Row>
      </div>

      <ErrorModal
        showError={showError}
        setShowError={setShowError}
        errorMessage={errorMessage}
        errorHeader={errorHeader}
      />
    </>
  );
};
export default Listdelete;

const ReadOnlyRows = ({
  member,
  handleEditClick,
  setMemberId,
  increment,
  nazeegTypeOptions,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(
      `מחיקת חבר "${
        member.first_name + " " + member.last_name
      }": האם אתה בטוח? `
    );
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const delData = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "jobs/memberlist/" + member.id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    delData();
    setMemberId(null);
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={member.id}
        event={deleteObj}
        message={deleteMessage}
      />

      <tr>
        <td>{member.first_name}</td>
        <td>{member.last_name}</td>
        <td>{member.idz}</td>
        <td>
          {
            nazeegTypeOptions.find((option) => option.id === member.nazeegType)
              ?.title
          }
        </td>
        <td>{member.tel}</td>
        <td>{member.email}</td>
        <td>{member.active ? "כן" : "לא"}</td>
        <td style={{ textAlign: "left" }}>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, member)}
          >
            <FiEdit2 />
          </button>
          <span> </span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) => showDeleteModal("member", member.id, event)}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};
